import { Menu, MenuButton, MenuItem, MenuList, MenuPopover, MenuTrigger } from "@fluentui/react-components";
import * as React from "react";

const runCommand = async (id: number, command: string, optionalstring?: any) => {
  const namespace =
    window.location.host.startsWith("localhost") || window.location.host.startsWith("exceldevstc")
      ? window.location.host.startsWith("localhost")
        ? "=EVEONLINEDEV" /* Dev */
        : "=EVEONLINETEST" /* Test */
      : "=EVEONLINE"; /* Prod */
  try {
    await Excel.run(async (context) => {
      /**
       * Insert your Excel code here
       */
      const range = context.workbook.getSelectedRange();
      // Read the range address
      range.load("address");
      let extra = "";
      if (typeof optionalstring == "string") extra = ',"' + optionalstring + '"';
      if (typeof optionalstring == "boolean") extra = "," + optionalstring + "";
      const pretty = namespace + command + "(" + id + extra + ")";
      range.values = [[pretty]];

      await context.sync();
    });
  } catch (error) {
    console.log(error);
  }
};

export interface CharacterCommandButtonProps {
  character_id: number;
}
export const CharacterCommandsButton = (Props: CharacterCommandButtonProps) => (
  <Menu>
    <MenuTrigger disableButtonEnhancement>
      <MenuButton>Functions</MenuButton>
    </MenuTrigger>

    <MenuPopover>
      <MenuList>
        <MenuItem onClick={() => runCommand(Props.character_id, ".CHARACTER", true)}>Character card</MenuItem>
        <MenuItem onClick={() => runCommand(Props.character_id, ".CHARACTER_CONTRACTS")}>Character contracts</MenuItem>
        <MenuItem onClick={() => runCommand(Props.character_id, ".CHARACTER_ORDERS")}>Orders</MenuItem>
        <MenuItem onClick={() => runCommand(Props.character_id, ".CHARACTER_ORDERS_HISTORY")}>Orders History</MenuItem>
        <MenuItem onClick={() => runCommand(Props.character_id, ".CHARACTER_WALLET_TRANSACTIONS")}>
          Transactions
        </MenuItem>
        <MenuItem onClick={() => runCommand(Props.character_id, ".CHARACTER_WALLET_JOURNAL")}>Journal</MenuItem>
        <MenuItem onClick={() => runCommand(Props.character_id, ".CHARACTER_ASSETS", "Rifter")}>Assets</MenuItem>
        <MenuItem onClick={() => runCommand(Props.character_id, ".CHARACTER_BLUEPRINTS")}>Blueprints</MenuItem>
        <MenuItem onClick={() => runCommand(Props.character_id, ".CHARACTER_SKILLS")}>Skills</MenuItem>
        <MenuItem onClick={() => runCommand(Props.character_id, ".CHARACTER_SKILL_QUEUE")}>Skill Queue</MenuItem>
        <MenuItem onClick={() => runCommand(Props.character_id, ".CHARACTER_PLANETS")}>PI Planets</MenuItem>
        <MenuItem onClick={() => runCommand(Props.character_id, ".CHARACTER_INDUSTRY_JOBS")}>Industry jobs</MenuItem>
        <MenuItem onClick={() => runCommand(Props.character_id, ".CHARACTER_FITTINGS")}>Fittings</MenuItem>
        <MenuItem onClick={() => runCommand(Props.character_id, ".CHARACTER_CLONES")}>Clones</MenuItem>
        <MenuItem onClick={() => runCommand(Props.character_id, ".CHARACTER_IMPLANTS")}>Implants</MenuItem>
      </MenuList>
    </MenuPopover>
  </Menu>
);
